import { CIPageStatus } from '../viewcomp/general/ci_pagestatus';

export function usePageStatus() {
    return CIPageStatus;
}
